/**
 * colsSettingParam 参数的说明和取的位置：

 *  应用编码 appcode    引入src/api/pageTo  pageTo.getAppCode()

*  页面编码 pagecode   引入src/api/pageTo  pageTo.getAppCode()

*  模板编码code        拿到整个页面的模板template template.code为模板编码

*  模板主键pageid      拿到整个页面的模板template template.pageid 为模板主键

*   区域编码areaCode    拿到整个页面的模板template areaCode是表格的区域编码 template[areaCode]可以拿到表格区域的模板信息

*   区域主键areaId      模板信息里的属性oid的值

 */
import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import Button from '../../Button';
import Tooltip from '../../Tooltip';
import ButtonGroup from '../../ButtonGroup';
import Dnd from '../../Dnd';
import Checkbox from '../../Checkbox'
import { ajax, toast, isString, removeMetaCache, isFunction, getGlobalStorage, setGlobalStorage } from '@platform/api'
import Sidebox from '../../Sidebox'
import 'bee-drawer/build/Drawer.css';

export default class ColumnMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            secondColumnShow: false, //自定义鼠标右键菜单显示
            showDrawer: false, //侧拉显示
            displayData: [], //左侧待选列显示模板
            sortData: [], //被选择排序的列显示模板
            columnsHaveTitle: [],
            rightData: [],
        };
        this.lockTotal = 0; //被锁定不能拖拽的列个数
        //this.keySessionS = ''; //localStorage缓存页面模板的key
    }

    componentDidMount() {
        // let { colsSettingParam } = this.props;
        // let { appcode, pagecode } = colsSettingParam;
        // //console.log("------------当前页面的pagecode为:" + pagecode)
        // //this.keySessionS = 'appTempletStorage_' + appcode + '_' + pagecode;
    }

    onMouseEnter = () => {
        this.setState({ secondColumnShow: true });
    };

    onMouseLeave = () => {
        this.setState({ secondColumnShow: false });
    };

    //发送请求获取模板取title 执行保存callback
    getColIncludeTitle = (isAsync = true, callback) => {
        let { colsSettingParam, columns } = this.props;
        let newColumns = columns.filter(val => val.itemtype !== 'customer');
        //tableType:是什么高阶表格
        //tabName:cardtable的页签名字
        let { appcode, pagecode, code, pageid, areaCode, tableType, tabName, hiddenLeftItem } = colsSettingParam;
        let finalAreaCode = areaCode;
        //用于兼容cardtable多页签
        if (tableType === 'cardtable' && tabName) {
            finalAreaCode = tabName;
        }
        ajax({
            url: '/nccloud/platform/template/getUserTemplateMap.do',
            async: isAsync,
            data: {
                appcode,
                pagecode,
                templatecode: code,
                templateId: pageid,
            },
            success: res => {
                // 获取左侧模板全部数据
                let areaList = res.data[0].areaList;
                //获取右侧表格显示数据
                let rightData = res.data[1][finalAreaCode].items;
                let items = areaList.filter(item => item.code == finalAreaCode)[0].formPropertyList;
                let cols =
                    items &&
                    items.map(val => {
                        val.title = val.label || val.display || val.value;
                        val.attrcode = val.code;
                        return val;
                    });
                let columnsHaveTitle = cols.filter(val => {
                    if (hiddenLeftItem && hiddenLeftItem.length) {
                        return (val.visible === true && !hiddenLeftItem.includes(val.attrcode))
                    } else {
                        return val.visible === true
                    }
                });
                //是否有自定义项
                let flag = newColumns.length !== items.length;
                let userDefineItems = [];
                if (flag) {
                    let rightAttrcode = newColumns.map(item => item.attrcode);
                    cols.map(item => {
                        if (rightAttrcode.includes(item.attrcode) && item.visible === false) {
                            userDefineItems.push(item);
                        }
                    });
                }
                if (flag) {
                    newColumns.map((val, index) => {
                        userDefineItems.map(item => {
                            if (item.attrcode === val.attrcode) {
                                columnsHaveTitle.splice(index, 0, item);
                            }
                        });
                    });
                }

                this.setState(
                    {
                        columnsHaveTitle,
                        rightData,
                        userDefineItems,
                    },
                    () => {
                        if (typeof callback === 'function') callback(columnsHaveTitle);
                    },
                );
            },
            error: err => {
                this.onRequestError(err);
            },
        });
    };

    //显示侧拉
    toShowDrawer = () => {
        let { colsSettingParam, columns } = this.props;

        this.lockTotal = 0;
        if (colsSettingParam) {
            //支持列设置的表格，从props取模板信息；取不到之后再发向后端获取
            if (columns && columns.length) {

                let { hiddenLeftItem } = colsSettingParam
                let newColumns = columns.filter(val => {
                    if (hiddenLeftItem && hiddenLeftItem.length) {
                        // 业务组会隐藏某些列
                        //changeMetaCol为了解决NCC-43188，改了模板，把itemtype改成customer
                        return (val.itemtype !== 'customer' || val.changeMetaCol === true) && !hiddenLeftItem.includes(val.attrcode)
                    } else {
                        return (val.itemtype !== 'customer' || val.changeMetaCol === true)
                    }

                });

                columns.forEach(val => {
                    if (val.islock) this.lockTotal++;
                });
                newColumns.forEach(val => {
                    if (val.fixed) delete val.fixed;
                });
                this.sortData = [...newColumns];
                this.getColIncludeTitle(true, items => {
                    //列设置
                    let userItems = this.state.userDefineItems.map(item => item.attrcode);
                    let newItems = items.map(val => {
                        //右侧已经存在则将左侧字段隐藏
                        val.showItem = true;
                        this.sortData.map((item, index) => {
                            if (item.attrcode == val.attrcode) {
                                if (item.visible === true) {
                                    val.showItem = false;
                                }
                                if (userItems.includes(val.attrcode)) {
                                    val.showItem = false;
                                    this.sortData[index].noDeletion = true;
                                }
                            }
                        });
                        return val;
                    });

                    this.setState({
                        displayData: [...newItems],
                        sortData: [...this.sortData],
                        showDrawer: true,
                    });
                });
                //   }
                // );
            }
        }
    };

    //关闭侧拉
    toCloseDrawer = () => {
        this.setState({ showDrawer: false });
        let element = ReactDOM.findDOMNode(this);
        if (element) {
            ReactDOM.unmountComponentAtNode(element);
            let parentElement = element.parentNode;
            parentElement && parentElement.removeChild(element);
        }
    };

    //拖拽结束
    onDragEnd = result => {
        let { sortData } = this.state;
        let unlockSortData = sortData.filter(val => val.islock !== true);
        let lockSortData = sortData.filter(val => val.islock === true);
        let { source, destination } = result;
        let startIndex = source.index;
        let endIndex = destination.index;
        let data1 = unlockSortData.splice(startIndex, 1);
        unlockSortData.splice(endIndex, 0, data1[0]);
        let newSortData = lockSortData.concat(unlockSortData);
        this.setState({ sortData: newSortData });
    };

    //点击选中侧拉左侧的列label事件
    chooseColumn = ele => {
        let { displayData } = this.state;
        let { sortData } = this.state;
        if (ele.showItem === true) {
            let newSortData = sortData.filter(val => val.attrcode !== ele.attrcode);
            let newDisplayData = displayData.map(val => {
                if (val.attrcode === ele.attrcode) {
                    //左侧隐藏
                    val.showItem = false;
                    val.islock = false;
                    //右侧显示
                    val.visible = true;
                    newSortData.push(val);
                }
                return val;
            });

            this.setState({
                displayData: newDisplayData,
                sortData: newSortData,
            });
        }
    };

    //点击X按钮让某一列隐藏
    ToHideOneCol = ele => {
        let { sortData, displayData } = this.state;
        if (ele.visible === true) {
            // let newSortData = sortData.filter(val => val.attrcode !== ele.attrcode);
            let newSortData = sortData.map(val => {
                if (val.attrcode === ele.attrcode) {
                    val.visible = false;
                    return val;
                }
                return val;
            });
            displayData = displayData.map(val => {
                if (val.attrcode === ele.attrcode) {
                    val.showItem = true;
                }
                return val;
            });
            this.setState({
                sortData: newSortData,
                displayData,
            });
        }
    };

    //点击锁锁定该列之前的列 锁定之后该列以及之前的列不参与排序
    ToLockCols = (ele, index) => {
        let { sortData } = this.state;
        /******************解决冻结所有列问题start**********************/
        let { tableScope } = this.props;
        let { json = {} } = tableScope.state;
        let tableBody = tableScope.table.querySelector('.u-table-body');
        let tableBodyWidth = 0;
        if (tableBody) { tableBodyWidth = tableBody.offsetWidth; }
        //第一列到点击的列的总宽度
        let toClickColWidth = 0;
        for (let i = 0, len = sortData.length; i < len; i++) {
            if (i == index) {
                break;
            }
            let width = sortData[i].width;
            if (isString(sortData[i].width)) {
                width = Number(sortData[i].width.replace(/px/, ''));
            }
            toClickColWidth += width;
        }

        if (tableBodyWidth < toClickColWidth) {
            toast({
                duration: 'infinity',
                color: 'warning',
                content: json['table_colseting_tip14'],
                mark: 'lock-tip',
            });
            return;
        }
        /***************** end**********************/
        let toLock = true;

        if (!ele.lock) {
            let afterLockData = sortData.map(val => {
                if (toLock === true && !val.islock) {
                    val.islock = true;
                    if (val.visible) this.lockTotal++;
                }
                if (val.attrcode === ele.attrcode) {
                    toLock = false;
                }
                return val;
            });
            this.setState({ sortData: afterLockData });
        }
    };

    //解锁
    ToUnLockCols = ele => {
        let { sortData } = this.state;
        if (ele.islock === true) {
            sortData = sortData.map(val => {
                if (val.islock === true) {
                    val.islock = false;
                    if (val.visible) this.lockTotal--;
                }
                return val;
            });
            this.setState({ sortData });
        }
    };

    iconfontCls = (fontName, another) => {
        return `icon iconfont icon-${fontName} ${another}`;
    };

    /**
     * 请求失败关闭侧拉、提示错误信息
     */
    onRequestError = err => {
        this.toCloseDrawer();
        console.error(err);
        let msgContent = JSON.stringify(err.message);
        toast({
            color: 'danger',
            content: msgContent,
            mark: 'save-table-columnSetting',
        });
    };

    /**
     * 列设置重置或者保存成功以后，更新ncTable和高阶业务表格的column
     */
    onSuccess = (metaColumns, successSMG, areaCode) => {
        let { updateColumnHandle } = this.props;
        this.toCloseDrawer();
        toast({ content: successSMG, light: true });
        updateColumnHandle(metaColumns, areaCode);
        // 卸载表格，重新加载 为了处理拖宽表格立即重置的情况
    };

    //保存列设置或者保存列宽的请求

    onSave = (metaColumns, ajaxColums, successSMG) => {
        let { colsSettingParam } = this.props;
        let { appcode, pagecode, code, pageid, areaCode, areaId, tableType, tabName } = colsSettingParam;
        let finalAreaCode = areaCode;
        //用于兼容cardtable多页签
        if (tableType === 'cardtable' && tabName) {
            finalAreaCode = tabName;
        }
        ajax({
            url: '/nccloud/platform/template/propertySetting.do',
            data: {
                appcode,
                pagecode,
                templatecode: code,
                templateId: pageid,
                [finalAreaCode]: {
                    areaId,
                    items: ajaxColums,
                },
            },
            success: res => {
                if (res.success) {
                    let { colsSettingParam } = this.props;
                    let { appcode, pagecode } = colsSettingParam;
                    //removeGlobalStorage('localStorage', this.keySessionS); //在列设置保存之后，移除当页面模板缓存，在重新
                    removeMetaCache(appcode, pagecode);

                    this.onSuccess(metaColumns, successSMG, finalAreaCode);
                }
            },
            error: err => {
                this.onRequestError(err);
            },
        });
    };

    //点击侧拉header的确定按钮
    onColsSetting = () => {
        let { tableScope } = this.props;
        let { sortData, columnsHaveTitle } = this.state;
        let { json = {} } = tableScope.state;
        let metaColums = [],
            ajaxColums = [];
        sortData.map(val => {
            let { width, attrcode } = val;
            //前端默认拼的120默认宽度不保存到后端
            let widthNS,
                title,
                propertyId;
            if (typeof width === 'string') {
                widthNS = width.match(/\d+/g)[0];
            }
            if (widthNS && (widthNS == 120 || widthNS == '120')) {
                widthNS = undefined;
            }
            columnsHaveTitle.forEach(item => {
                if (attrcode === item.code) {
                    title = item.title;
                    propertyId = item.pk_form_property;
                }
            });
            let widthObj = widthNS ? { width: widthNS } : {};
            let enableCol = this.deleteVDom(val);

            metaColums.push({
                ...enableCol,
                propertyId,
                ...widthObj,
                label: title,
                title,
                islock: val.islock ? val.islock : false,
            });
            ajaxColums.push({
                ...enableCol,
                propertyId,
                ...widthObj,
                label: title,
                title,
                islock: val.islock ? val.islock : false,
            });
        });
        let { rightData } = this.state;

        let ajax = [...rightData],
            show = [];

        rightData.map((item, index) => {
            ajaxColums.map(ii => {
                if (ii.propertyId === item.propertyId) {
                    show.push(index);
                }
            });
        });
        show.forEach((ss, index) => {
            ajax[ss] = ajaxColums[index];
        });
        this.onSave(metaColums, ajax, json['table_colseting_tip02']); //'列设置保存成功'
    };

    //点击重置 重置列设置
    onColReset = () => {
        let { colsSettingParam, tableScope } = this.props;
        let { appcode, pagecode, code, pageid, areaCode, tableType, tabName, hiddenLeftItem } = colsSettingParam;
        let { json = {} } = tableScope.state;
        // 兼容cardtable多页签
        let finalAreaCode = areaCode;
        if (tableType === 'cardtable' && tabName) {
            finalAreaCode = tabName;
        }
        let url = '/nccloud/platform/template/removeUserPropertySettings.do';
        ajax({
            url,
            data: {
                templateId: pageid,
                areaId: finalAreaCode,
            },
            success: res => {
                if (res.success) {
                    ajax({
                        url: '/nccloud/platform/template/getUserTemplateMap.do',
                        data: {
                            appcode,
                            pagecode,
                            templatecode: code,
                            templateId: pageid,
                        },
                        success: result => {
                            //removeGlobalStorage('localStorage', this.keySessionS);
                            removeMetaCache(appcode, pagecode);

                            let areaList = result.data[0].areaList;
                            let rightData = result.data[1][finalAreaCode].items;
                            let { userDefineItems } = this.state;
                            let userItems = userDefineItems.map(item => item.attrcode);
                            let items = areaList.filter(item => item.code == finalAreaCode)[0].formPropertyList;
                            let metaColums = [];

                            rightData.map(data => {
                                items.map(item => {
                                    if (data.propertyId === item.pk_form_property) {
                                        let obj = data;
                                        obj.width = item.width;
                                        if (userItems.includes(data.attrcode)) {
                                            obj.visible = true;
                                        }
                                        metaColums.push(obj);
                                    }
                                });
                            });
                            if (hiddenLeftItem && hiddenLeftItem.length) {
                                metaColums = metaColums.filter(val => !hiddenLeftItem.includes(val.attrcode))
                            }
                            this.onSuccess(metaColums, json['table_colseting_tip04'], finalAreaCode);
                        },
                        error: err => {
                            this.onRequestError(err);
                        },
                    });
                }
            },
            error: err => {
                this.onRequestError(err);
            },
        });
    };

    //列宽保存
    onTableWithSave = () => {
        let { columns, tableScope } = this.props;
        let { columnsHaveTitle } = this.state;
        let { json = {} } = tableScope.state;

        let newColumns = columns.filter(item => {
            return item.attrcode !== 'blankrow'
        });
        // for (let index = 0; index < columns.length; index++) {
        //     const element = columns[index];
        //     if(element.attrcode === 'blankrow'){
        //         columns.splice(index, 1)
        //     }
        // }
        // 取真实dom宽度
        // let colColumns = tableScope.table.querySelectorAll('.u-table-scroll .u-table-header colgroup col')
        // let leftColumns = tableScope.table.querySelectorAll('.u-table-fixed-left .u-table-header colgroup col')
        // let rightColumns = tableScope.table.querySelectorAll('.u-table-fixed-right .u-table-header colgroup col')
        // for (let i = 0, len = columns.length; i < len; i++) {
        //     //兼容多表头
        //     let childnum = 0; //子表头个数
        //     if (columns[i].children) {
        //         columns[i].children.map((child, childIndex) => {
        //             child.width = colColumns[i + childIndex].style.width;
        //         });
        //         childnum += columns[i].children.length - 1;
        //     } else {
        //         let obj = { ...columns[i] };
        //         if (obj.fixed === 'left') {
        //             obj.width = leftColumns[i + childnum].style.width;
        //         } else if (obj.fixed === 'right') {
        //             obj.width = rightColumns[0].style.width;
        //         } else {
        //             obj.width = colColumns[i + childnum - leftColumns.length].style.width;
        //         }
        //         newColumns.push(obj)
        //     }
        // }
        let metaColums = [],
            ajaxColums = [];
        newColumns.forEach(val => {
            let { attrcode, width } = val;
            //前端默认拼的120默认宽度不保存到后端
            let widthNS,
                title,
                propertyId;
            if (typeof width === 'string') {
                widthNS = width.match(/\d+/g)[0];
            } else if (typeof width === 'number') {
                widthNS = width.toFixed(0)
            }
            if (widthNS && (widthNS == 120 || widthNS == '120')) {
                widthNS = undefined;
            }
            columnsHaveTitle &&
                columnsHaveTitle.length &&
                columnsHaveTitle.forEach(item => {
                    if (attrcode === item.code) {
                        title = item.label || item.display || item.value;
                        propertyId = item.pk_form_property;
                    }
                });
            let widthObj = widthNS ? { width: widthNS } : {};
            let enableCol = this.deleteVDom(val);

            metaColums.push({
                ...enableCol,
                ...widthObj,
                propertyId,
                label: title,
                title,
                islock: val.islock ? val.islock : false,
            });
            ajaxColums.push({
                ...enableCol,
                ...widthObj,
                propertyId,
                label: title,
                title,
                islock: val.islock ? val.islock : false,
            });
        });
        let { rightData } = this.state;

        let ajax = [...rightData];
        ajax.forEach(item => {
            ajaxColums.map(ii => {
                if (ii.propertyId === item.propertyId) {
                    item.width = ii.width;
                }
            });
        });
        this.onSave(metaColums, ajax, json['table_colseting_tip01']); //'列宽保存成功'
    };

    //删除列里可能包含虚拟dom的字段
    deleteVDom = col => {
        let excludeVDom = Object.assign({}, col);
        delete excludeVDom.title;
        delete excludeVDom.sorter;
        delete excludeVDom.render;
        delete excludeVDom.width;
        return excludeVDom;
    };

    // platform.template.resetwidth
    // 重置列宽
    resetWidth = () => {
        let { colsSettingParam, tableScope } = this.props;
        let { appcode, pagecode, code, pageid, areaCode, tableType, tabName } = colsSettingParam;
        let { json = {} } = tableScope.state;
        //添加重置列宽的标识
        tableScope.resetWidthFlag = true;
        // 兼容cardtable多页签
        let finalAreaCode = areaCode;
        if (tableType === 'cardtable' && tabName) {
            finalAreaCode = tabName;
        }
        let url = '/nccloud/platform/template/resetwidth.do';

        ajax({
            url,
            data: {
                templateId: pageid,
                areaId: finalAreaCode,
            },
            success: res => {
                if (res.success) {
                    ajax({
                        url: '/nccloud/platform/template/getUserTemplateMap.do',
                        data: {
                            appcode,
                            pagecode,
                            templatecode: code,
                            templateId: pageid,
                        },
                        success: result => {
                            // removeGlobalStorage('localStorage', this.keySessionS);
                            removeMetaCache(appcode, pagecode);

                            let areaList = result.data[0].areaList;
                            let items = areaList.filter(item => item.code == finalAreaCode)[0].formPropertyList || [];
                            let { columns } = this.props;
                            let oldColums = columns.filter(val => val.itemtype !== 'customer' || val.changeMetaCol === true);

                            let metaColumns = [];
                            oldColums.map(oldItem => {
                                let width = 120,
                                    title;
                                items.map(newItem => {
                                    if (newItem.code == oldItem.attrcode) {
                                        width = Number(newItem.width) || 120;
                                        title = newItem.label;
                                    }
                                });
                                let enableCol = this.deleteVDom(oldItem);

                                metaColumns.push({
                                    ...enableCol,
                                    width,
                                    title,
                                });
                            });

                            this.onSuccess(metaColumns, json['table_colseting_tip03'], finalAreaCode);
                        },
                        error: err => {
                            this.onRequestError(err);
                        },
                    });
                }
            },
            error: err => {
                this.onRequestError(err);
            },
        });
    };

    //侧拉的头部结构
    DrawerHeader = () => {
        let { colsSettingParam, tableScope } = this.props;
        let { json = {} } = tableScope.state;
        if (colsSettingParam) {
            let LIST = [
                {
                    title: json['table_colseting_ok'], //确定
                    colors: 'primary',
                    key: 'confirm',
                    onClick: this.onColsSetting,
                    className: 'button-primary',
                },
                {
                    title: json['table_colseting_reset'], //重置
                    key: 'reset',
                    colors: 'secondary',
                    onClick: this.onColReset,
                },
            ];

            const tip = (
                <div>
                    <p>{json['table_colseting_tip05']}:</p>
                    <p>1. {json['table_colseting_tip06'] + `"${json['table_colseting_waitadd']}"` + json['table_colseting_tip07'] + json['table_colseting_tip08']}
                        <i className='iconfont icon-shanchu4' />，{json['table_colseting_tip09']}
                    </p>
                    <p>2. {json['table_colseting_tip10'] + `"${json['table_colseting_readyadd']}"` + json['table_colseting_tip07'] + json['table_colseting_tip11']}
                        <i className='iconfont icon-tuozhuai' />，{json['table_colseting_tip12']}
                    </p>
                    <p>3. {json['table_colseting_tip06']}<i className='iconfont icon-weisuoding' />{json['table_colseting_tip13']}</p>
                </div>
            );

            return (
                <div className="setTableColumnDrawer-header">
                    <h3 className="title">
                        {json['table_colseting_table']} {/*列表设置*/}
                        <Tooltip
                            placement="right"
                            className='col-setting-tips'
                            overlay={tip}
                        >
                            <i className='iconfont icon-bangzhutishi' />
                        </Tooltip >
                    </h3>
                    <div className="headerBtns">
                        <ButtonGroup list={LIST} />
                        <Button className="cancel-btn" onClick={this.toCloseDrawer}>
                            {json['table_colseting_cancel']} {/*取消*/}
                        </Button>
                    </div>
                </div>
            );
        }
    };

    //拖拽排序列表
    sortColumnList = () => {
        let { sortData } = this.state;
        let { tableScope } = this.props;
        let { json = {} } = tableScope.state;

        let alreadShowColumns = sortData.filter(val => val.islock !== true);
        let orderIndex = this.lockTotal;

        return alreadShowColumns.map(val => {
            if (val.visible) orderIndex++;
            return (
                <div key={val.attrcode} className={`${val.visible ? 'show-column' : 'hide-column'}`}>
                    <span className="order">{orderIndex}</span>
                    <span className="label">{val.label}</span>
                    <span onClick={!(val.noDeletion || val.redstar) && this.ToHideOneCol.bind(this, val)}>
                        <Tooltip
                            placement="top"
                            overlay={json['table_colseting_hide']}
                            delayHide={1}
                            delayShow={1000}
                        >
                            <i
                                className={this.iconfontCls('shanchu4', 'close')}
                                style={(val.noDeletion || val.redstar) ? { color: '#aeaeae', cursor: 'not-allowed' } : {}}
                            />
                        </Tooltip>
                    </span>
                    <span onClick={this.ToLockCols.bind(this, val, orderIndex)}>
                        <Tooltip
                            placement="top"
                            overlay={json['table_colseting_lock']}
                            delayHide={1}
                            delayShow={1000}
                        >
                            <i
                                className={this.iconfontCls('weisuoding', 'toLock')}
                            />
                        </Tooltip>
                    </span>
                    <Tooltip
                        placement="top"
                        overlay={json['table_colseting_sort']}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i className={this.iconfontCls('tuozhuai', 'handle')} />
                    </Tooltip>
                </div>
            );
        });
    };

    autoFold = () => {
        let { tableScope, colsSettingParam } = this.props;
        let { state, props } = tableScope;
        let { foldingRowChange, foldCacheId } = props;
        let { isEllipsis } = state;
        let newIsEllipsis = !isEllipsis
        tableScope.setState({ isEllipsis: newIsEllipsis })
        isFunction(foldingRowChange) && foldingRowChange(newIsEllipsis)
        let { appcode, pagecode, areaCode } = colsSettingParam
        let fold_localStorage

        let userDataJSON = getGlobalStorage('localStorage', "STOREFORINFODATA");
        let userData = userDataJSON && JSON.parse(userDataJSON);
        let userid = userData && userData.userId;

        if (!appcode || !pagecode || !areaCode) {
            fold_localStorage = foldCacheId + '_' + userid
        } else {
            fold_localStorage = 'foldFlag_' + appcode + '_' + pagecode + '_' + areaCode + '_' + userid;
        }
        if (fold_localStorage) {
            let fold_flag = getGlobalStorage('localStorage', 'fold_flag') || {}
            if (typeof fold_flag === 'string') {
                fold_flag = JSON.parse(fold_flag)
            }
            if (newIsEllipsis === false) {
                fold_flag[fold_localStorage] = 'isFold'
                setGlobalStorage('localStorage', 'fold_flag', JSON.stringify(fold_flag))
            } else {
                delete fold_flag[fold_localStorage]
                setGlobalStorage('localStorage', 'fold_flag', JSON.stringify(fold_flag))
            }
        }
    }

    render() {
        let { secondColumnShow, showDrawer, sortData, displayData } = this.state;
        let { tableScope, cancelColSetting } = this.props;
        let { state, props } = tableScope;
        let lockedData = sortData.filter(val => val.islock === true && val.visible === true);
        let { json = {}, isEllipsis } = state;
        let { isDrag = true, showWidthAndHeightConfig = true } = props;
        return (
            <Fragment>
                {/* <li className="MouseRightListItem">过滤（ctrl+f）</li> */}
                {isDrag && showWidthAndHeightConfig && (
                    <li
                        onMouseEnter={this.onMouseEnter}
                        onMouseLeave={this.onMouseLeave}
                        className="MouseRightListItem columnWidthSetting hasChildMenu"
                    >
                        <span>
                            {json['table_colseting_width']}
                            {/* 宽高设置 */}
                        </span>
                        {secondColumnShow && (
                            <div className="second">
                                <ul className="rightMenu secondColumn" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                                    <li className="MouseRightListItem" onClick={this.autoFold}>
                                        <div>
                                            <span className={'rightMenu-fold'}>
                                                <Checkbox
                                                    className={'fold-checkbox'}
                                                    checked={!isEllipsis}
                                                    onChange={this.autoFold}
                                                />
                                                {json["table_colseting_tip15"]}{/*自动换行 */}
                                            </span>
                                        </div>
                                    </li>
                                    {!cancelColSetting && <li className="MouseRightListItem">
                                        <div
                                            onClick={() => {
                                                this.getColIncludeTitle(false, this.onTableWithSave);
                                            }}
                                        >
                                            {json['table_colseting_savewidth']}
                                            {/* 保存列宽 */}
                                        </div>
                                    </li>}
                                    {!cancelColSetting && <li className="MouseRightListItem">
                                        <div
                                            onClick={() => {
                                                this.resetWidth();
                                            }}
                                        >
                                            {json['table_colseting_reset']}
                                            {/* 重置 */}
                                        </div>
                                    </li>}
                                </ul>
                            </div>
                        )}
                    </li>
                )}

                {!cancelColSetting && <li className="MouseRightListItem columnOrder">
                    <div onClick={this.toShowDrawer}>
                        {json['table_colseting_table']}
                        {/* 列表设置 */}
                    </div>
                </li>}

                {showDrawer && (
                    <Sidebox
                        title={this.DrawerHeader()}
                        show={showDrawer}
                        // placement="right"
                        mask={true}
                        maskClose={this.toCloseDrawer}
                        width={1000}
                        onClose={this.toCloseDrawer}
                        // destroyOnClose={true} //关闭时候是否销毁抽屉的内容
                        className="setTableColumnDrawer"
                    >
                        <div className="TableColumnContent">
                            <ul className="TableColumnContent-left">
                                <h3 className="TableColumnContent-title">
                                    {json['table_colseting_waitadd']}
                                    {/*待添加*/}
                                </h3>
                                {displayData.map((val, i) => {
                                    let isRowEndItem = false;
                                    if ((i + 1) % 4 === 0) isRowEndItem = true;
                                    return (
                                        <li
                                            key={val.attrcode}
                                            className={`per-column ${val.showItem === true ? '' : 'unselectedColumn'} ${isRowEndItem ? 'row-end-item' : ''}`}
                                        >
                                            <div onClick={this.chooseColumn.bind(this, val)}>
                                                <span className="plusBtn">+</span>
                                                {val.required && <span className="unselected-mark">*</span>}
                                                <span className="Column-label">{val.label}</span>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                            <div className="TableColumnContent-right">
                                <h3 className="TableColumnContent-title">
                                    {json['table_colseting_readyadd']}
                                    {/*已添加*/}
                                </h3>
                                <ul className="lockedCol">
                                    {lockedData.map((val, index) => {
                                        return (
                                            <li key={val.attrcode} className={`${val.visible ? 'show-column' : 'hide-column'}`}>
                                                <span className="order">{index + 1}</span>
                                                <span className="label">{val.label}</span>
                                                {lockedData.length - 1 === index ? (
                                                    <Tooltip
                                                        placement="top"
                                                        overlay={json['table_colseting_lock']}
                                                        delayHide={1}
                                                        delayShow={1000}
                                                    >
                                                        <i
                                                            className={this.iconfontCls('suoding', 'unLock')}
                                                            onClick={this.ToUnLockCols.bind(this, val)}
                                                        />
                                                    </Tooltip>
                                                ) : null}
                                            </li>
                                        );
                                    })}
                                </ul>
                                {this.sortColumnList() && this.sortColumnList().length ? (
                                    <Dnd
                                        list={this.sortColumnList()}
                                        onStop={this.onDragEnd}
                                        dragClass="alreadyShow-column"
                                        bounds=".TableColumnContent-right"
                                        type="vertical"
                                    />
                                ) : null}
                            </div>
                        </div>
                    </Sidebox>
                )}
            </Fragment>
        );
    }
}
